export const URL_SEARCHFIELDMAPPINGS = '/api/searchfieldmappings/';

export default {};
